class CartRemoveButton extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', (event) => {
            event.preventDefault();

            const lineIndex = this.dataset.index;
            const bundleId = this.closest('.cart-item').dataset.bundleId;

            if (bundleId && bundleId !== '' && bundleId !== 'false') {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        const itemsToRemove = {};

                        cart.items.forEach(item => {
                            const itemBundleId = item.properties?._bundle_id || item.properties?.bundle_id;
                            if (itemBundleId === bundleId) {
                                itemsToRemove[item.key] = 0;
                            }
                        });

                        return fetch('/cart/update.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ updates: itemsToRemove })
                        });
                    })
                    .then(response => {
                        if (!response.ok) throw new Error('Could not update cart');
                        return response.json();
                    })
                    .then(() => {
                        window.location.assign(window.location.href);
                    })
                    .catch(error => {
                        console.error('Cart update failed:', error);
                        // fallback reload
                        window.location.assign(window.location.href);
                    });

            } else {
                const cartItemsComponent = this.closest('cart-items') || this.closest('cart-drawer-items');
                cartItemsComponent.updateQuantity(lineIndex, 0);
            }
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement =
            document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        const debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') {
                return;
            }
            this.onCartUpdate();
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    onChange(event) {
        this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute('name'),
            event.target.dataset.quantityVariantId,
            event.target.dataset.bundleId
        );
        if (event.target.dataset.bundleId != undefined && event.target.dataset.bundleId != false && event.target.dataset.bundleId != '' && event.target.dataset.bundleId != 'false') {
            setTimeout(() => {
                // this.updateQuantityEngraving(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
            }, 1000)
        }
    }

    onCartUpdate() {
        if (this.tagName === 'CART-DRAWER-ITEMS') {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                    for (const selector of selectors) {
                        const targetElement = document.querySelector(selector);
                        const sourceElement = html.querySelector(selector);
                        if (targetElement && sourceElement) {
                            targetElement.replaceWith(sourceElement);
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        } else {
            fetch(`${routes.cart_url}?section_id=main-cart-items`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const sourceQty = html.querySelector('cart-items');
                    this.innerHTML = sourceQty.innerHTML;
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section',
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-subtotal-below-items',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.cart__subtotal-source',
            },
            {
                id: 'cart-gift-progress',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '#cart-gift-progress',
            },
        ];
    }

    updateQuantity(line, quantity, name, variantId, bundleId) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll('.cart-item');

                if (parsedState.errors) {
                    quantityElement.value = quantityElement.getAttribute('value');
                    this.updateLiveRegions(line, parsedState.errors);
                    return;
                }

                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    const previousGiftProgress = section.id === 'cart-gift-progress'
                        ? elementToReplace.querySelector('.cart-gift-progress')?.style.getPropertyValue('--cart-gift-progress')
                        : null;
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );

                    if (previousGiftProgress) {
                        const updatedGiftProgress = elementToReplace.querySelector('.cart-gift-progress');
                        const nextGiftProgress = updatedGiftProgress?.style.getPropertyValue('--cart-gift-progress');

                        if (updatedGiftProgress && nextGiftProgress) {
                            if (parseFloat(previousGiftProgress) < 100 && parseFloat(nextGiftProgress) >= 100) {
                                updatedGiftProgress.classList.add('cart-gift-progress--celebrate');
                            }
                            updatedGiftProgress.style.setProperty('--cart-gift-progress', previousGiftProgress);
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    updatedGiftProgress.style.setProperty('--cart-gift-progress', nextGiftProgress);
                                });
                            });
                        }
                    }
                }));
                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                let message = '';
                if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                    if (typeof updatedValue === 'undefined') {
                        message = window.cartStrings.error;
                    } else {
                        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                    }
                }
                this.updateLiveRegions(line, message);

                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                }
                publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
            }).catch(() => {
            this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
        })
            .finally(() => {
                this.disableLoading(line);
                if (bundleId != undefined && bundleId != false && bundleId != '' && bundleId != 'false') {
                    setTimeout(() => {
                        this.updateQuantityEngraving(line, quantity, name, variantId, bundleId);
                    }, 1500)
                }
            });
    }

    updateQuantityEngraving(line, quantity, name, variantId, bundleId) {
        line = parseInt(line) + 1;
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll('.cart-item');

                if (parsedState.errors) {
                    quantityElement.value = quantityElement.getAttribute('value');
                    this.updateLiveRegions(line, parsedState.errors);
                    return;
                }

                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);


                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    const previousGiftProgress = section.id === 'cart-gift-progress'
                        ? elementToReplace.querySelector('.cart-gift-progress')?.style.getPropertyValue('--cart-gift-progress')
                        : null;
                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

                    if (previousGiftProgress) {
                        const updatedGiftProgress = elementToReplace.querySelector('.cart-gift-progress');
                        const nextGiftProgress = updatedGiftProgress?.style.getPropertyValue('--cart-gift-progress');

                        if (updatedGiftProgress && nextGiftProgress) {
                            if (parseFloat(previousGiftProgress) < 100 && parseFloat(nextGiftProgress) >= 100) {
                                updatedGiftProgress.classList.add('cart-gift-progress--celebrate');
                            }
                            updatedGiftProgress.style.setProperty('--cart-gift-progress', previousGiftProgress);
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    updatedGiftProgress.style.setProperty('--cart-gift-progress', nextGiftProgress);
                                });
                            });
                        }
                    }
                }));

                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                let message = '';

                if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                    if (typeof updatedValue === 'undefined') {
                        message = window.cartStrings.error;
                    } else {
                        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                    }
                }
                this.updateLiveRegions(line, message);

                const lineItem =
                    document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                }
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
            })
            .catch(() => {
                this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
                this.disableLoading(line);
            });
    }

    updateLiveRegions(line, message) {
        const lineItemError =
            document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus =
            document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
}

customElements.define('cart-items', CartItems);

function onCheckoutClick(event) {
    const checkoutButton = event.target.closest('[name="checkout"]');
    if (!checkoutButton || checkoutButton.disabled) return;

    event.preventDefault();
    checkoutButton.setAttribute('aria-disabled', 'true');
    checkoutButton.disabled = true;

    const formId = checkoutButton.getAttribute('form');
    const checkoutForm = formId ? document.getElementById(formId) : checkoutButton.closest('form');
    if (checkoutForm) {
        checkoutButton.removeAttribute('aria-disabled');
        checkoutButton.disabled = false;

        // requestSubmit preserves the clicked submitter (`name="checkout"`), unlike form.submit().
        if (typeof checkoutForm.requestSubmit === 'function') {
            checkoutForm.requestSubmit(checkoutButton);
            return;
        }

        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Checkout';
        checkoutForm.appendChild(checkoutInput);
        checkoutForm.submit();
    } else {
        window.location.href = '/checkout';
    }
}

document.addEventListener('click', onCheckoutClick, true);

if (!customElements.get('cart-note')) {
    customElements.define(
        'cart-note',
        class CartNote extends HTMLElement {
            constructor() {
                super();

                this.addEventListener(
                    'input',
                    debounce((event) => {
                        const body = JSON.stringify({ note: event.target.value });
                        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
                    }, ON_CHANGE_DEBOUNCE_TIMER)
                );
            }
        }
    );
}
